// src/pages/SubDealer/ViewSubDealers.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import subDealerService from '../../services/subDealer.service';
import './ViewSubDealers.css';

const ViewSubDealers = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [subDealers, setSubDealers] = useState([]);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage]             = useState(1);
  const [total, setTotal]           = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const limit = 10;

  useEffect(() => {
    const timer = setTimeout(() => {
      const isAdmin = ['SUPER_ADMIN', 'OFFICE_ADMIN'].includes(user?.role);
      const companyId = isAdmin ? localStorage.getItem('selectedCompanyId') : null;

      if (isAdmin && !companyId) {
        setError('Please select a company first');
        return;
      }

      setLoading(true);
      setError(null);

      subDealerService.getAllSubDealers(companyId, page, limit, searchTerm)
        .then(res => {
          if (res.success) {
            setSubDealers(res.data.subDealers || []);
            setTotal(res.data.pagination.total);
            setTotalPages(res.data.pagination.totalPages);
          }
        })
        .catch(err => setError(err.response?.data?.message || 'Failed to fetch sub-dealers'))
        .finally(() => setLoading(false));
    }, 400);

    return () => clearTimeout(timer);
  }, [page, searchTerm, user]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this sub-dealer?')) return;
    try {
      const res = await subDealerService.deleteSubDealer(id);
      if (res.success) setPage(p => p);  // trigger refresh
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete');
    }
  };

  return (
    <div className="view-subdealers-container">
      <div className="subdealers-header">
  <h4 className="subdealers-title">View Sub-Dealers</h4>
  <button className="btn-add-dealer" onClick={() => navigate('/sub-dealer/add')}>
    + Add Sub-Dealer
  </button>
</div>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by shop name, owner, mobile, parent dealer..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
        />
      </div>

      {loading ? (
        <div className="loading-container"><div className="spinner"></div><p>Loading...</p></div>
      ) : error ? (
        <div className="error-container"><p className="error-message">{error}</p></div>
      ) : subDealers.length === 0 ? (
        <div className="empty-state">
          <p>No sub-dealers found{searchTerm ? ` matching "${searchTerm}"` : ''}</p>
          {!searchTerm && (
  <button className="btn-add-dealer" onClick={() => navigate('/sub-dealer/add')}>
    + Add Sub-Dealer
  </button>
)}
        </div>
      ) : (
        <>
          <div className="table-container">
            <table className="subdealers-table">
              <thead>
                <tr>
                  <th>SHOP NAME</th>
                  <th>OWNER</th>
                  <th>MOBILE</th>
                  <th>PARENT DEALER</th>
                  <th>HQ</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {subDealers.map((sd) => (
                  <tr key={sd.id}>
                    <td>{sd.subDealerShopName}</td>
                    <td>{sd.ownerName}</td>
                    <td>{sd.mobile}</td>
                    <td>{sd.dealer?.dealerShopName || '—'}</td>
                    <td>{sd.dealer?.headquarter?.name || '—'}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="btn-action btn-view" onClick={() => navigate(`/sub-dealer/view/${sd.id}`)}>View</button>
                        <button className="btn-action btn-edit" onClick={() => navigate(`/sub-dealer/edit/${sd.id}`)}>Edit</button>
                        <button className="btn-action btn-delete" onClick={() => handleDelete(sd.id)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="pagination">
            <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</button>
            <span className="pagination-info">Page {page} of {totalPages} ({total} total)</span>
            <button className="pagination-btn" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewSubDealers;